import { EventBus } from "../eventBus/nav-bar-event";
import globals from '../globals'
// Notification Mixin
export default {
    data() {
      return {
      };
    },
    methods: {
      
      async getexpenseList(params){
        return new Promise(async(resolve, reject) => {
          try{
            let response = await this.$http.post(globals.EXPENSE_API + '/expenses/list_expense', params)
            console.log(response)
            if(response.data.status_id){
              resolve(response.data)
            } else {
              reject(response.data.reason)
            }
          }
          catch(error){
            reject(error.response.data.reason)
          }
        })
      },
    },
  };
  


// WEBPACK FOOTER //
// ./src/components/mixins/expense.js